export const MAIN_URL = `https://graphql.contentful.com/content/v1/spaces/${process.env.REACT_APP_SPACE_ID}`;

export const MENU = [
	// {
	// 	name: "Шини ЛІТО",
	// 	link: "tour",
	// },
	// {
	// 	name: "Creativity",
	// 	link: "tracks",
	// }, 
	// {
	// 	name: "Шини ЗИМА",
	// 	link: "news",
	// },
	{
		name: "Каталог дисків",
		link: "shop",
	},
];

export const SOCIALS = [
	// {
	// 	icon: "youtube",
	// 	link: "https://www.youtube.com",
	// },
	// {
	// 	icon: "twitter",
	// 	link: "https://twitter.com",
	// },
	// {
	// 	icon: "applemusic",
	// 	link: "https://music.apple.com",
	// },
	// {
	// 	icon: "tiktok",
	// 	link: "https://www.tiktok.com",
	// },
	// {
	// 	icon: "instagram",
	// 	link: "https://www.instagram.com",
	// },
	// {
	// 	icon: "spotify",
	// 	link: "https://open.spotify.com",
	// },
];

export const SLIDER_BUTTON_TYPES = {
	NEXT: "NEXT",
	PREV: "PREV",
};
